import React, { useEffect } from 'react';
import { sortBy } from 'lodash';
import { WidthAndHeightSubProps } from '../../puck/reusable-props/widthAndHeight';
import { Cart } from '../../interface/checkoutInterface';
import { Shop } from '../../interface/storeInterface';
import './../text-editor/style.scss';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { StoreProps } from '../../services/constants';
import { CustomizeProps } from '../../interface/commonInterface';
import './index.scss';
import { PaddingType } from '../../puck/reusable-props/padding';
import { getBorderProps, getPaddingStyles } from '../../utils/helper';
import { IBorderValueProps } from '../../puck/reusable-props/Border';
import { IProductModalProps } from './AddProductModal';
import { TypedUseSelectorHook } from 'react-redux';
import {
  setPredefinedUpsellProduct,
  setSelectedProductsForMultiProducts,
} from '../../redux/slices/postUpsellSlice';
import { setIsLoading } from '../../redux/slices/postUpsellStateSlice';
import { checkAndReturnWithProductVariantIdPrefix } from '../../utils/constants';

export interface PreviewProductProps {
  pageId: string | null;
  data: IProductModalProps[];
  selectedProduct: string;
  setSelectedProduct: (_value: string) => void;
  currentDeviceType: 'desktop' | 'mobile' | 'tablet';
  image: WidthAndHeightSubProps;
  cartData?: Cart | null;
  dispatch?: ThunkDispatch<StoreProps, unknown, AnyAction>;
  storeData?: Shop;
  productTitle: CustomizeProps;
  maxContainerWidth: string;
  borderForProducts: IBorderValueProps;
  useAppSelector?: TypedUseSelectorHook<StoreProps>;
  radioColor: string;
  radioSize: string;
  tagPosition: string;
  tagStyles: {
    isBlink: string;
    borderTopLeft: string;
    borderTopRight: string;
    borderBottomLeft: string;
    borderBottomRight: string;
    padding: PaddingType;
    backgroundColor: string;
  };
}

export const PreviewProduct: React.FC<PreviewProductProps> = ({
  data,
  selectedProduct,
  currentDeviceType,
  image,
  setSelectedProduct,
  productTitle,
  tagStyles,
  maxContainerWidth,
  borderForProducts,
  radioColor,
  radioSize,
  tagPosition,
  useAppSelector,
  dispatch,
}) => {
  const sortedData = sortBy(data, 'order');
  const currentUpsellData =
    useAppSelector &&
    useAppSelector(state => state.postUpSell.currentUpsellData);

  function removeBackgroundColor(htmlString: string) {
    return htmlString.replace(/background-color\s*:\s*[^;"]+;?/gi, '');
  }

  useEffect(() => {
    const defaultProduct = sortedData?.find(
      item => item.productDetails.id === selectedProduct,
    );
    const variantWithPrefix = checkAndReturnWithProductVariantIdPrefix(
      `${defaultProduct?.productDetails?.variantid || sortedData?.[0]?.productDetails?.variantid}`,
    );
    const newMultiProductsSelectedItems = [];
    newMultiProductsSelectedItems.push({
      variantId: variantWithPrefix,
      GroupId: currentUpsellData?.upsellgroup_id || '',
      IsDownsell: currentUpsellData?.isDownSell || false,
      DownsellId: currentUpsellData?.isDownSell
        ? currentUpsellData?.downsell_id
        : '',
      ProductId: `${defaultProduct?.productDetails?.id || sortedData?.[0]?.productDetails?.id}`,
    });
    if (dispatch) {
      dispatch(
        setPredefinedUpsellProduct(
          `${defaultProduct?.productDetails?.id || sortedData?.[0]?.productDetails?.id}`,
        ),
      );
      dispatch(
        setSelectedProductsForMultiProducts(newMultiProductsSelectedItems),
      );
    }
  }, [sortedData]);

  return (
    <>
      {sortedData?.map((item, index) => {
        const inputId = `productSelection-${index}`;
        let isSelected;
        if (selectedProduct) {
          isSelected = item?.productDetails?.id === selectedProduct;
        } else {
          isSelected = index === 0; // Default to the first product if none is  default selected
        }
        return (
          <label
            key={item.order}
            htmlFor={inputId}
            className={`${item?.isHighlight ? 'elevate-scale' : ''} px-[10px] ${item.isTag && item.tagText && tagPosition === 'top' ? 'pt-[10px] pb-[20px]' : 'pt-[10px] pb-[10px]'} transition-colors duration-200 ${borderForProducts?.borderStyle?.[currentDeviceType]} cursor-pointer text-editor-content`}
            style={{
              ...getBorderProps(borderForProducts, currentDeviceType),
              backgroundColor:
                item?.isHighlight && item?.highlightColor
                  ? item.highlightColor
                  : 'inherit',
            }}>
            {item.isTag && item.tagText && tagPosition === 'top' && (
              <div
                dangerouslySetInnerHTML={{
                  __html: removeBackgroundColor(item.tagText),
                }}
                className={`${tagStyles?.isBlink === 'yes' ? 'pulsing-button' : ''} overflow-hidden ml-2`}
                style={{
                  ...getPaddingStyles(tagStyles?.padding, currentDeviceType),
                  width: maxContainerWidth,
                  backgroundColor: tagStyles?.backgroundColor,
                  borderTopLeftRadius: isNaN(+tagStyles?.borderTopLeft)
                    ? tagStyles?.borderTopLeft
                    : tagStyles?.borderTopLeft + 'px',
                  borderTopRightRadius: isNaN(+tagStyles?.borderTopRight)
                    ? tagStyles?.borderTopRight
                    : tagStyles?.borderTopRight + 'px',
                  borderBottomLeftRadius: isNaN(+tagStyles?.borderBottomLeft)
                    ? tagStyles?.borderBottomLeft
                    : tagStyles?.borderBottomLeft + 'px',
                  borderBottomRightRadius: isNaN(+tagStyles?.borderBottomRight)
                    ? tagStyles?.borderBottomRight
                    : tagStyles?.borderBottomRight + 'px',
                }}
              />
            )}
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-4 w-full">
                <input
                  type="radio"
                  style={{
                    width: isNaN(+radioSize) ? radioSize : +radioSize,
                    height: isNaN(+radioSize) ? radioSize : +radioSize,
                    backgroundColor: isSelected ? radioColor : 'transparent',
                  }}
                  id={inputId}
                  name="productSelection"
                  className="cursor-pointer"
                  value={item.productDetails.id}
                  checked={isSelected}
                  onChange={event => {
                    try {
                      setSelectedProduct(event.target.value);
                      const variantWithPrefix =
                        checkAndReturnWithProductVariantIdPrefix(
                          '' + item?.productDetails?.variantid,
                        );
                      const newMultiProductsSelectedItems = [];
                      newMultiProductsSelectedItems.push({
                        variantId: variantWithPrefix,
                        GroupId: currentUpsellData?.upsellgroup_id || '',
                        IsDownsell: currentUpsellData?.isDownSell || false,
                        DownsellId: currentUpsellData?.isDownSell
                          ? currentUpsellData?.downsell_id
                          : '',
                        ProductId: `${item?.productDetails?.id}` || '',
                      });
                      if (dispatch) {
                        dispatch(
                          setSelectedProductsForMultiProducts(
                            newMultiProductsSelectedItems,
                          ),
                        );
                        dispatch(setIsLoading(false));
                      }
                    } catch (error) {
                      console.error('Error changing product:', error);
                    }
                  }}
                />
                <img
                  src={
                    item.addAlias
                      ? process.env.REACT_APP_S3_BUCKET_URL + item.aliasImageUrl
                      : item.productDetails.imageUrl
                  }
                  alt={item.productDetails.name}
                  style={{
                    width: isNaN(+image?.maxWidth?.[currentDeviceType])
                      ? image?.maxWidth?.[currentDeviceType]
                      : +image?.maxWidth?.[currentDeviceType],
                    height: isNaN(+image?.height?.[currentDeviceType])
                      ? image?.height?.[currentDeviceType]
                      : +image?.height?.[currentDeviceType],
                  }}
                  className="object-contain border rounded-md bg-white"
                  decoding="async"
                />
                <div>
                  {item.isTag && item.tagText && tagPosition === 'right' && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: removeBackgroundColor(item.tagText),
                      }}
                      className={`${tagStyles?.isBlink === 'yes' ? 'pulsing-button' : ''} overflow-hidden`}
                      style={{
                        ...getPaddingStyles(
                          tagStyles?.padding,
                          currentDeviceType,
                        ),
                        width: maxContainerWidth,
                        backgroundColor: tagStyles?.backgroundColor,
                        borderTopLeftRadius: isNaN(+tagStyles?.borderTopLeft)
                          ? tagStyles?.borderTopLeft
                          : tagStyles?.borderTopLeft + 'px',
                        borderTopRightRadius: isNaN(+tagStyles?.borderTopRight)
                          ? tagStyles?.borderTopRight
                          : tagStyles?.borderTopRight + 'px',
                        borderBottomLeftRadius: isNaN(
                          +tagStyles?.borderBottomLeft,
                        )
                          ? tagStyles?.borderBottomLeft
                          : tagStyles?.borderBottomLeft + 'px',
                        borderBottomRightRadius: isNaN(
                          +tagStyles?.borderBottomRight,
                        )
                          ? tagStyles?.borderBottomRight
                          : tagStyles?.borderBottomRight + 'px',
                      }}
                    />
                  )}
                  <p
                    className={`${productTitle?.fontSize?.[currentDeviceType]} ${productTitle?.weight?.[currentDeviceType]} text-wrap w-full`}
                    style={{
                      color: productTitle?.textColor?.[currentDeviceType],
                    }}>
                    {item.addAlias ? item.aliasName : item.productDetails.name}
                  </p>
                </div>
              </div>
              <span className="text-sm font-semibold" style={{ width: '45%' }}>
                {item.isDisplayPrice && item.displayPrice ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.displayPrice,
                    }}
                  />
                ) : (
                  <span>${item.totalCartPrice}</span>
                )}
              </span>
            </div>
          </label>
        );
      })}
    </>
  );
};

export default PreviewProduct;
